export default __webpack_public_path__ + "static/media/meet_now_icon.f5e45382.svg";